export const importTypes: { text: string; value: string }[] = [
    { text: "Organisation Structure", value: "organisationStructure" },
    { text: "Work Groups", value: "workGroups" },
    { text: "Health Surveillance Fit For Work Case", value: "healthSurveillanceFitForWorkCase" },
    { text: "Bulk Leavers", value: "bulkLeavers" },
    { text: "Bulk PPQ Cases", value: "bulkPpqCases" },
    { text: "Organisation Levels", value: "organisationLevels" },
    { text: "Employee Records", value: "employeeRecords" },
    { text: "Customer Users", value: "customerUsers" }
];
